<template>
	<v-dialog
		v-model="openModal"
		v-bind="$attrs"
		:max-width="maxWidth"
	>
		<v-card>
			<v-toolbar
				dark
				color="primary"
			>
				<v-btn
					icon
					dark
					@click="openModal = false"
				>
					<v-icon>mdi-close</v-icon>
				</v-btn>
				<v-toolbar-title>
					<slot name="header" />
				</v-toolbar-title>
				<v-spacer />
				<v-toolbar-items>
					<v-row>
						<v-col>
							<slot name="toolbar-items" />
						</v-col>
					</v-row>
				</v-toolbar-items>
			</v-toolbar>
			<v-card-title primary-title />
			<v-card-text>
				<slot />
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<slot name="action" />
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	components: {},
	props: { value: Boolean, maxWidth: { type: Number, default: 900 } },
	data () {
		return {};
	},
	computed: {
		openModal: {
			get () {
				return this.value;
			},
			set (val) {
				this.$emit("input", val);
			},
		},
	},
};
</script>

<style scoped>

</style>
